export interface IOrderDiscount {
  label: string;
  discountValue: number;
}
